module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/CabalTemp.json
// module id = 598
// module chunks = 1